import { useEffect, useState } from "react";

// ---- Customer profile (name + phone) persisted on-device ----
const NAME_KEY = "goldys.customer_name";
const PHONE_KEY = "goldys.customer_phone";

export function saveCustomerProfile(profile) {
  localStorage.setItem(NAME_KEY, profile.name || "");
  localStorage.setItem(PHONE_KEY, profile.phone || "");
}

export function useCustomerProfile() {
  const [profile, setProfile] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const name = localStorage.getItem(NAME_KEY) || "";
    const phone = localStorage.getItem(PHONE_KEY) || "";
    if (phone) setProfile({ name, phone });
    setReady(true);
  }, []);

  const update = (next) => {
    setProfile(next);
    saveCustomerProfile(next);
  };

  return { profile, ready, update };
}

// ---- Anonymous device id for games ----
const DEVICE_ID_KEY = "goldys.games_device_id";
export function useDeviceId() {
  const [deviceId, setDeviceId] = useState("");
  useEffect(() => {
    let existing = localStorage.getItem(DEVICE_ID_KEY);
    if (!existing) {
      existing = (crypto.randomUUID && crypto.randomUUID()) || `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(DEVICE_ID_KEY, existing);
    }
    setDeviceId(existing);
  }, []);
  return deviceId;
}

// ---- Saved pickup addresses ----
const ADDR_KEY = "goldys.saved_addresses";
export const ADDRESS_LABELS = ["Home", "Office", "Other"];

export function useSavedAddresses() {
  const [addresses, setAddresses] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      const list = JSON.parse(localStorage.getItem(ADDR_KEY) || "[]");
      setAddresses(Array.isArray(list) ? list : []);
    } catch {
      setAddresses([]);
    }
    setReady(true);
  }, []);

  const persist = (next) => {
    setAddresses(next);
    localStorage.setItem(ADDR_KEY, JSON.stringify(next));
  };

  const save = (label, address, location) => {
    const trimmed = (address || "").trim();
    const withoutDupes = addresses.filter((a) => a.address !== trimmed && a.label !== label);
    const entry = { id: `${Date.now()}`, label, address: trimmed };
    if (location) {
      entry.lat = location.lat;
      entry.lng = location.lng;
    }
    persist([entry, ...withoutDupes]);
  };

  const remove = (id) => persist(addresses.filter((a) => a.id !== id));

  return { addresses, ready, save, remove };
}
